import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import ChainedBackend from 'i18next-chained-backend'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import { trackTraceTranslationsI18nBackend } from '@dhl/tracktrace'
import { dataLayerPublish } from '@dhl/datalayer'
import { getConfig } from '~/config/index.js'
import { locales, localStorageLocale } from '~/config/locales.js'

export { locales, localStorageLocale }

// Content hashed translation files per locale, only defined in production builds (HashedTranslationsPlugin)
// eslint-disable-next-line no-underscore-dangle, @typescript-eslint/naming-convention -- injected by the DefinePlugin
declare const __TRANSLATION_FILES__: Record<string, string> | undefined
const translationFiles = typeof __TRANSLATION_FILES__ === 'undefined' ? undefined : __TRANSLATION_FILES__

const { apiGatewayHost } = getConfig()

const languageDetector = new LanguageDetector()

languageDetector.addDetector({
  name: 'detectPrimary',
  lookup() {
    return locales()[0]
  },
})

i18next
  .use(languageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(ChainedBackend as any) // eslint-disable-line @typescript-eslint/no-explicit-any
  .init({
    backend: {
      backends: [HttpApi, trackTraceTranslationsI18nBackend({ apiGatewayHost })],
      backendOptions: [
        {
          loadPath: (lngs: string[], ns: string[]) => {
            if (ns.includes('translation')) {
              const hashedFile = translationFiles?.[lngs[0]]

              return hashedFile ? `/portal/${hashedFile}` : `/portal/i18n/{{lng}}.json`
            }
            return undefined
          },
        },
      ],
    },

    ns: ['translation', 'trackTrace'],
    defaultNS: 'translation',
    fallbackNS: 'trackTrace',
    saveMissing: true,
    showSupportNotice: false,
    missingKeyHandler: (_lngs, _ns, key) => {
      dataLayerPublish('ERROR', {
        id: 'i18n',
        message: `i18n - missing '${i18next.language}' translation for key '${key}'`,
      })
    },
    debug: false,
    supportedLngs: locales(),
    returnNull: false,
    detection: {
      order: ['localStorage', 'navigator', 'detectPrimary'],
      lookupLocalStorage: localStorageLocale,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  })

export const i18n: typeof i18next = i18next
